import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Storage } from '@ionic/storage';
import { Subject } from 'rxjs';
import { Suscripcion } from '../model/suscripcion.model';

import { JSEncrypt } from './../../assets/js/jsencrypt.js';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ServicioService {

    urlInventario = 'https://leonisavirtual.leonisa.com/leonisa_pedido_war/rest/retail/getInventory';

    urlReferenciaChannel = 'https://us-central1-retaildigitalleonisa20.cloudfunctions.net/api';

    urlCrossSelling = 'https://leonisavirtual.leonisa.com/leonisa_pedido_war/rest/retail/marketBasket';

    urlMongo = 'https://us-central1-retaildigitalleonisa20.cloudfunctions.net/api/';

    urlParrilla = 'https://leonisavirtualtest.leonisa.com/leonisa_pedido_war/rest/retail/getInventoryDeparments'

    private eventCart = new Subject<any>();
    private eventPais = new Subject<any>();

    constructor(
        private httpClient: HttpClient,
        private storage: Storage
    ) {
    }

    publishCountryData(data: any) {
        this.eventPais.next(data);
    }

    getObservableCountry(): Subject<any> {
        return this.eventPais;
    }

    publishCartData(data: any) {
        this.eventCart.next(data);
    }

    getObservableCart(): Subject<any> {
        return this.eventCart;
    }




    async getReferencia(pais: any, ref: any) {

        if (ref === '981BYC') {
            ref = '981';
        }

        // const res = await this.httpClient.get(this.urlMongo + 'rdldata/' + pais + '/' + ref).toPromise();
        if (pais === 'co') {
            // const res = await this.httpClient.get(this.urlInventario + '/' + ref).toPromise();
            const res = await this.httpClient.get(this.urlMongo + 'rdldata/12013421/' + ref).toPromise();
            return res;
        } else if (pais === 'us') {
            const res = await this.httpClient.get(this.urlMongo + 'rdldata/50000133/' + ref).toPromise();
            return res;
        } else if (pais === 'es') {
            const res = await this.httpClient.get(this.urlMongo + 'rdldata/50000387/' + ref).toPromise();
            return res;
        } else if (pais === 'ec') {
            const res = await this.httpClient.get(this.urlMongo + 'rdldata/12007733/' + ref).toPromise();
            return res;
        } else if (pais === 'pe') {
            const res = await this.httpClient.get(this.urlMongo + 'rdldata/12020076/' + ref).toPromise();
            return res;
        } else if (pais === 'cl') {
            const res = await this.httpClient.get(this.urlMongo + 'rdldata/12020060/' + ref).toPromise();
            return res;
        } else if (pais === 'cr') {
            const res = await this.httpClient.get(this.urlMongo + 'rdldata/12028126/' + ref).toPromise();
            return res;
        } else if (pais === 'pr') {
            const res = await this.httpClient.get(this.urlMongo + 'rdldata/12017069/' + ref).toPromise();
            return res;
        } else if (pais === 'pa') {
            const res = await this.httpClient.get(this.urlMongo + 'rdldata/12032277/' + ref).toPromise();
            return res;
        } else if (pais === 'mx') {
            const res = await this.httpClient.get(this.urlMongo + 'rdldata/12013835/' + ref).toPromise();
            return res;
        } else {
            const res = await this.httpClient.get(this.urlInventario + '/' + ref).toPromise();
            return res;
        }
    }


    async getReferenciaChannel(pais: any, ref: any) {

        if (ref === '981BYC') {
            ref = '981';
        }

        // return await this.httpClient.get(this.urlReferenciaChannel + '/rdldata/' + pais + '/' + ref)
        return await this.httpClient.get(this.urlMongo + '/rdldata/' + ref)
            .toPromise().then(res => {
                return res;
            }).catch(err => {
                // console.log('failed' + err);
                return err;
            });
    }


    getCrossSelling(ref: any) {
        return this.httpClient.get(this.urlCrossSelling + '/' + ref);
    }

    getParrilla(sec: any) {
        return this.httpClient.get(this.urlParrilla + '/' + sec)
            .toPromise()
            .then(res => {
                return res;
            }).catch(err => {
                return err;
            });
    }

    // ***************************************** VARIABLES EN STORAGE ******************************************************

    setVariable(variable: string, valor: any) {
        return this.storage.set(variable, valor);
    }

    getVariable(variable: string) {
        return this.storage.get(variable);
    }

    deleteVariable(variable: string) {
        return this.storage.remove(variable);
    }

    async subscription(suscripcion: Suscripcion) {
        suscripcion.fechaNacimiento = suscripcion.fechaNacimiento.substring(0, 10).replace('-', '').replace('-', '');
        // console.log('JSON.stringify(suscripcion)', JSON.stringify(suscripcion));
        // console.log('url', this.urlMongo + 'cddata');
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.httpClient.post(this.urlMongo + 'cddata', JSON.stringify(suscripcion), httpOptions)
            .toPromise()
            .then(async (res) => {
                // console.log('res', res);
                return res;
            }).catch(err => {
                // console.log('error', err);
                return err;
            });
    }

    async getnum() {
        return await this.httpClient.put(this.urlMongo + 'preventa', null)
            .toPromise()
            .then(res => {
                return res;
            }).catch(err => {
                return err;
            });
    }


    async dsiPreventa(datos: any) {
        // return await this.httpClient.get(this.urlReferenciaChannel + '/rdldata/' + pais + '/' + ref)
        return await this.httpClient.post(this.urlMongo + 'preventa', datos)
            .toPromise().then(res => {
                return res;
            }).catch(err => {
                // console.log('failed' + err);
                return err;
            });
    }

    // *************************************  Onmicanal *******************************************

    // TOKEN
    // 

    async getTokenOmnicanal() {

        // const PUBLIC_KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkXd2U6i+zcpcTgotn4JcecYYcMQK/4zbxPJiEtkw2B/c1fgZDHsce34VIT23DQ532vNfsodEwqY34dIbdbS5pdMKt8jBEPPVFC7t8b3nweEu9QjhzTGqlPN+Ht1vrsrokIy2t8AUdHxGuNNkLIpV2j/1Lb03mRRdC30jdCvmq9NZINjDNYqDAqRrYSTIVseaQQlVGdhZufNsXX74ejqNquB9enJKLhuAVM/Xgb0f8LWdmnWFt9AsBtSp8m/TAvj6mwCm5nOeBBopOfWpBd39ZOEsUnf5/qIp8qbVKTz3GSC7XlkQPIEJ1dGf9k/2rrdWyFBd4zrhXV0tDYU/Va3IgQIDAQAB';
        // const PUBLIC_KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAx/0C/ZVDH21kyFQc0qy4uBbAUph/3T0Bki73bJsNFXbvKhIi0LbbXADBoZQXJHG5WHdZSXK6h6Nj0JdGd1E45oBPk7pUmwu2hcGLO75/7i0a/N2yABd+xHqLWpezTz7ptsbDoiRfUFj/3kBgdm7xPV6ScSLKoSfVZGLyKlj0sZXhQnJgFB68Rp4cSYjq1zVw0j2FNNMuFhIMDuKGDfLuUuiFO1H7fX7P1pa7MV9AITt81wrI9LAXle9jMmc294TxFxtjIxlSkx5wX+9OHEJmvTEbEZ7POcB3rOm66n6juDmAiMFs+9ktkByq/YbkDlBsb4l3reFheFV2fV1DzzBC9QIDAQAB'
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(environment.PUBLIC_KEY);

        const user = encrypt.encrypt('71694935');
        const pass = encrypt.encrypt('dm35');
        const company = encrypt.encrypt('800081664-9');


        // const json = {
        //     'user': 'QqPmKCuRWtRohEKBtLXjT4CV0r+sAT1uNRNyVPYYXafKSCDMrh4NsBYUxm6hUjnpj2J8c84gXg3rtt3NLvgJDGtSLdkuMRilcNEYQc0y12WXU1joUNUOO9Kol9JE5lL+AWkKzR6x947B/2lXHugHN+aFJlVHxEE6dQ5pROrHvkAkFqxHlsQDZL5p/WulN8hphCt2JL9BbCB/5Yie30sst586F/OkmXnnsxhe1x9pFox6Og2RGrVeK+TpmqG8U0tE1YJQk8BhlmKz0XKrK+KCLiEtq/fivq8n7CyNYhq8GrWq9/FxxZZ49tlr1Y7eXgGOQCU/GlCZFy9BTRk6OAsmzw==',
        //     'pass': 'AoX7YrLvudTZfXcyYzqdU5b4aGKd2VXoN+s5JO01B24cDnnFP0B+/eMUIvY5TKMT+aQwcWDxr8jmqPzSsasdABScU6eK1DHWZIJ3zRyAdAxPjhbiS58LcZQbblicR4crNN5ZbSk9ExlaYBejsDv4lE7RD9b27AYZ9iReCPqTtor/VGlrPFCQGMeczDxzmBS/gguzIIBwUv6S8JMefOeOHqfd2m3cmvmA5eYbX1jwbloXNAisAegpvVoilBBfP6pmjcu/2rvk3QbTd5Opz+1Sk+9gnE4htimdt1rJlMRrGO43T5YNW3RNjcjpXXo9WFWha/uHLtL94VMOc2JArbMxhg==',
        //     'company': 'KBJVWz69yRVTLq5/eTUESUTAM586MNX4h9w2+SHhfmz2dx8mfDOVURQhrhdsPioONyscxNCEmeaa+wpVsxhb5ogqFZbqB652rgni3aK6jmI3zxhZ9n6a6Ery3Fn+00lUNxvR3FsU7nuSIwbX0NDbRpgWTVULiwiUKDcJUcADc16QjNF6WM+Wg82LEw8zamTV9kN8uMF/zu4lgBAD+fpiHSktrS56ag6SKgBn50nE4kIiU1Axuj3qsEL2IXMl+qtzsW796S9oruGoWOAR3ybJ5+gmuAdwwKyE1f67Q5U5Apg9sfmMOPhIy+GOnmpgH+pQya02vaebFLIpE6bii1IsLw=='
        // }

        const json = {
            'user': user,
            'pass': pass,
            'company': company
        }

        // return await this.httpClient.get(this.urlReferenciaChannel + '/rdldata/' + pais + '/' + ref)
        return await this.httpClient.post('https://leonisavirtual.leonisa.com/pos-service/service/authentication/userPos', json)
            .toPromise().then(res => {
                return res;
            }).catch(err => {
                // console.log('failed' + err);
                return err;
            });
    }



    async inventarioExpress(datos: any, token: string, consumer: string) {

        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(environment.PUBLIC_KEY);
        const user = encrypt.encrypt('71694935');

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
                'user': user,
                'consumer': consumer
            })
        };

        return await this.httpClient.post('https://leonisavirtual.leonisa.com/pos-service/service/omnicanal/getInventory', datos, httpOptions)
            .toPromise().then(res => {
                return res;
            }).catch(err => {
                // console.log('failed' + err);
                return err;
            });
    }


}
